import posthog from "posthog-js";
import { EPostHogEventName } from "../const/const";
import { useEffect } from "react";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { isCookieAllowed, POSTHOG_COOKIE_KEY, useCookieConsentStore } from "@/zapi-frontend/shared/hooks/useCookieConsent";

let isPostHogInitialized = false;

function isPostHogEnabled(): boolean {
  return isPostHogInitialized && !posthog.has_opted_out_capturing();
}

export function initPostHogClient() {
  const postHogKey = import.meta.env.VITE_POSTHOG_KEY_ZAPI;
  const postHogHost = import.meta.env.VITE_POSTHOG_HOST_ZAPI;

  if (!postHogKey) return null;

  posthog.init(postHogKey, {
    api_host: postHogHost,
    person_profiles: "identified_only",
    opt_out_capturing_by_default: true,
    opt_out_persistence_by_default: true,
    opt_out_capturing_persistence_type: "localStorage"
  });
  isPostHogInitialized = true;

  return posthog;
}

export function syncPostHogAfterConsent() {
  if (!isPostHogInitialized) return;
  const { userId } = useCookieConsentStore.getState();
  if (isCookieAllowed(POSTHOG_COOKIE_KEY, userId)) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}

export function enablePostHog() {
  if (!isPostHogInitialized) return;
  posthog.opt_in_capturing();
}

export function disablePostHog() {
  if (!isPostHogInitialized) return;
  posthog.opt_out_capturing();
}

export function firePostHogEvent(event: EPostHogEventName) {
  if (isPostHogEnabled()) {
    posthog.capture(event);
  }
}

export function identifyByEmailPostHog(email: string) {
  if (isPostHogEnabled()) {
    posthog.identify(email, { email });
  }
}

export function fireAnalyticsEvent(event: EPostHogEventName) {
  firePostHogEvent(event);
}

export function useIdentifySessionByEmail() {
  const { email } = useMeStore();

  useEffect(() => {
    if (email) {
      identifyByEmailPostHog(email);
    }
  }, [email]);
}
